import React, { ChangeEvent } from 'react';
import { InputStyle } from './Styles';

const Input = React.forwardRef<any, Props>((({
  width,
  minWidth,
  maxWidth,
  height,
  borderRadius,
  backgroundColor,
  border,
  marginLeft,
  marginTop,
  marginRight,
  marginBottom,
  style,
  type,
  letterSpacing,
  placeholderColor,
  placeholderOpacity,
  placeFontFamily,
  placeFontSize,
  placeholder,
  value,
  lineHeight,
  onChange,
  fontSize,
  fontFamily,
  autoFocus,
  inputMode,
  color,
}, ref) => {
  let curFontFamily: any;
  let curFontWeight: any;
  if (fontFamily === 'Squad-SemiBold') {
    curFontFamily = 'Squad-SemiBold, Squad';
    curFontWeight = 600;
  }
  else if (fontFamily === 'Squad-SemiBoldItalic') {
    curFontFamily = 'Squad-SemiBoldItalic, Squad';
    curFontWeight = 600;
  }
  else if (fontFamily === 'Squad-Regular') {
    curFontFamily = 'Squad-Regular, Squad';
    curFontWeight = 400;
  }
  else if (fontFamily === 'Squad-ExtraBold') {
    curFontFamily = 'Squad-ExtraBold, Squad';
    curFontWeight = 800;
  }
  else if (fontFamily === 'Squad-Bold') {
    curFontFamily = 'Squad-Bold, Squad';
    curFontWeight = 'bold';
  }
  else if (fontFamily === 'PingFangSC-SemiBold') {
    curFontFamily = 'PingFangSC-SemiBold, PingFang SC';
    curFontWeight = 600;
  }
  else if (fontFamily === 'PingFangSC-Regular') {
    curFontFamily = 'PingFangSC-Regular, PingFang SC';
    curFontWeight = 400;
  }
  else if (fontFamily === 'PingFangSC-Medium') {
    curFontFamily = 'PingFangSC-Medium, PingFang SC';
    curFontWeight = 500;
  }
  else if (fontFamily === 'Inter-Regular') {
    curFontFamily = 'Inter-Regular, Inter';
    curFontWeight = 400;
  }
  else if (fontFamily === 'Inter-Light') {
    curFontFamily = 'Inter-Light, Inter';
    curFontWeight = 300;
  }
  else if (fontFamily === 'Inter-SemiBold') {
    curFontFamily = 'Inter-SemiBold, Inter';
    curFontWeight = 600;
  }
  else if (fontFamily === 'Inter-Medium') {
    curFontFamily = 'Inter-Medium, Inter';
    curFontWeight = 700;
  }
  else if (fontFamily === 'Inter-MediumItalic') {
    curFontFamily = 'Inter-MediumItalic, Inter';
    curFontWeight = 700;
  }
  else if (fontFamily === 'Inter-Bold') {
    curFontFamily = 'Inter-Bold, Inter';
    curFontWeight = 800;
  }

  return (
    <InputStyle
      ref={ref}
      type={type}
      style={{
        width,
        minWidth,
        maxWidth,
        height,
        borderRadius,
        backgroundColor,
        border: border ? border : 'none',
        marginLeft,
        marginTop,
        marginRight,
        marginBottom,
        fontSize,
        color,
        letterSpacing,
        fontFamily: curFontFamily,
        fontWeight: curFontWeight,
        lineHeight: lineHeight ? lineHeight + 'px' : undefined,
        ...style,
      }}
      placeholderColor={placeholderColor}
      placeholderOpacity={placeholderOpacity}
      placeFontFamily={placeFontFamily}
      placeFontSize={placeFontSize}
      placeholder={placeholder}
      value={value}
      autoFocus={autoFocus}
      inputMode={inputMode}
      onChange={(e) => {
        if (onChange) {
          onChange(e);
        }
      }}
    />
  );
}));

interface Props {
  width?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
  height?: number | string;
  backgroundColor?: string;
  borderRadius?: number | string;
  border?: string;
  marginLeft?: number;
  marginTop?: number;
  marginRight?: number,
  marginBottom?: number,
  style?: React.CSSProperties;
  type?: 'text' | 'password' | 'checkbox' | 'radio' | 'submit' | 'reset' | 'button' | 'number' | 'email' | 'url' | 'date' | 'time' | 'datetime-local' | 'tel';
  letterSpacing?: number | string;
  placeholderColor?: string;
  placeholderOpacity?: number;
  placeFontFamily?: string;
  placeFontSize?: number;
  placeholder?: string;
  value?: string;
  lineHeight?: number;
  fontSize?: number;
  autoFocus?: boolean;
  inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search';
  color?: string;
  fontFamily?: 'Squad-SemiBold' | 'Squad-SemiBoldItalic' | 'Squad-Regular' | 'Squad-ExtraBold' | 'Squad-Bold' | 'PingFangSC-SemiBold' | 'PingFangSC-Regular' | 'PingFangSC-Medium' | 'Inter-Regular' | 'Inter-Light' | 'Inter-SemiBold' | 'Inter-Medium' | 'Inter-MediumItalic' | 'Inter-Bold',
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export default Input;
